import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customOptions: [],
};

const customSelectSlice = createSlice({
  name: "customSelect",
  initialState,
  reducers: {
    addCustomOption(state, action) {
      if (!state.customOptions.includes(action.payload)) {
        state.customOptions.push(action.payload);
      }
    },
  },
});

export const { addCustomOption } = customSelectSlice.actions;
export default customSelectSlice.reducer;
